import { unsafeCSS } from 'lit';
import { border, color, spacing } from '../css.helper';

export const TopReviewBlockStyles = unsafeCSS(`
  background-color: ${color('blue', 100)};
  border: ${border(1, 'grey', 400)};
  border-block-end: 0;
  border-radius: ${spacing(100, 100, 0, 0)};
  margin: 0;
  padding: ${spacing(250, 250, 0, 250)};
`);
